import React, { useState, useEffect } from "react";
import NavLayout from "../../../layout/navLayout";
import Tabs from "../../../components/common/tabs";
import { useDispatch, useSelector } from "react-redux";
import { changeActiveTabs } from "../../../store/slices/orders/ordersSlice";
import Details from "./details";
import Product from "./product";
import { useLocation, useNavigate } from "react-router-dom";
import { readData, checkCkycStatus } from "../../../service/order/orderService";
import { BackArrowIcon } from "../../../assets/images/svg/svg";
import { orders, kyc } from "../../../utils/router/constant";
import Documents from "./documents";
import Transaction from "./transaction";
import { getParamsFromURL } from "../../../utils/helper";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";

const SelectedOrder = () => {
  const dispatch = useDispatch();
  const tabs = useSelector((state) => state.orders.selectedOrder.tab);
  const activeTab = useSelector(
    (state) => state.orders.selectedOrder.activeTabs
  );
  const location = useLocation();
  const navigate = useNavigate();

  const [orderId, setOrderId] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(false);

  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setOrderId(params["orderId"] || params["order_id"]);
        } else {
          // Fallback to plain query parameters
          const searchParams = new URLSearchParams(location.search);
          const oId = searchParams.get("orderId") || searchParams.get("order_id");
          if (oId && oId !== "undefined" && oId !== "null") {
            setOrderId(oId);
          } else {
            console.error("No parameters found");
          }
        }
      });
    };
    fetchCode();
  }, [location]);

  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );

  const memberId = detailsData?.billing_member_id || detailsData?.member_id || detailsData?.member_ckyc?.member_id || "";

  useEffect(() => {
    if (orderId && orderId !== "undefined" && orderId !== "null") {
      readData(orderId, "ODR").catch((err) => {
        console.error("Failed to read order details:", err);
      });
    }
  }, [orderId]);

  useEffect(() => {
    if (detailsData) {
      console.log("SelectedOrder detailsData loaded:", detailsData);
    }
  }, [detailsData]);

  useEffect(() => {
    return () => {
      dispatch(changeActiveTabs("details"));
    };
  }, [dispatch]);

  const handleBackClick = () => {
    navigate(orders);
  };

  const handleCheckStatus = async () => {
    if (!orderId || !memberId) {
      toast.error("Invalid Order or Member information");
      return;
    }
    setCheckingStatus(true);
    try {
      const res = await checkCkycStatus(memberId, orderId);
      toast.info(`KYC Status checked: ${res.kyc_status || "Pending"}`);
      await readData(orderId, "ODR");
    } catch (err) {
      const errMsg = err?.response?.data?.error_message || "Failed to check status";
      toast.error(errMsg);
    } finally {
      setCheckingStatus(false);
    }
  };

  return (
    <NavLayout>
      <div className="order--detail__view">
        <div className="order-header">
          <span className="back-arrow" onClick={handleBackClick}>
            <BackArrowIcon />
          </span>
          <div className="order-title">{detailsData.code}</div>
        </div>



        <div className="main-content-wrapper-tab">
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            changeActiveTab={(tab) => dispatch(changeActiveTabs(tab))}
          />
          <div className="selected-tab-bottom-content">
            {activeTab === "details" && <Details />}
            {activeTab === "product" && <Product code={orderId} />}
            {activeTab === "transaction" && <Transaction code={orderId} />}
            {activeTab === "documents" && <Documents />}
          </div>
        </div>
      </div>
    </NavLayout>
  );
};

export default SelectedOrder;

